import { createSelector } from 'reselect';

const uiStateSelector = (state) => state.ui;

export const sidebarOpenSelector = createSelector(
  uiStateSelector,
  (state) => state.sidebarOpen
);
